import Controller from '@ember/controller';

export default class MarketSettingsSpiderSpiderDashboardController extends Controller {
  queryParams = ['legacy_mapping_settings'];
  dashboard;

  get iframeQPs() {
    return {
      iframe: 1,
      origin: window.location.origin,
      legacy_mapping_settings: this.legacy_mapping_settings,
    };
  }
}
